import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#space" }),
    /*#__PURE__*/_createTextVNode(" Space ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Even though we have Divider, but sometimes we need more than one Divider to split the elements apart, so we stack each elements upon Divider, but doing so not only makes our code ugly but also makes it difficult to maintain. Space is this kind of component provides us both productivity and elegance. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUIVerticalLayout = _resolveComponent("EUIVerticalLayout")
  const _component_EUIControlTheSizeOfTheSpace = _resolveComponent("EUIControlTheSizeOfTheSpace")
  const _component_EUICustomizedSize = _resolveComponent("EUICustomizedSize")
  const _component_EUIAutoWrapping = _resolveComponent("EUIAutoWrapping")
  const _component_EUISpacer = _resolveComponent("EUISpacer")
  const _component_EUIAlignment = _resolveComponent("EUIAlignment")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUIVerticalLayout),
    _createVNode(_component_EUIControlTheSizeOfTheSpace),
    _createVNode(_component_EUICustomizedSize),
    _createVNode(_component_EUIAutoWrapping),
    _createVNode(_component_EUISpacer),
    _createVNode(_component_EUIAlignment)
  ], 64))
}